export default __webpack_public_path__ + "static/media/dishop.811ee55e.png";